import React from 'react';
import './FNav.css'
import { Link } from 'react-router-dom';


const FNav = () => {
    return ( 
        <div className='Fnav'>
            <ul>
                <Link className='Link' to='/'>
                    <li>
                        Overview
                    </li>
                </Link>
                <Link className='Link' to='/'>
                    <li>
                        Birth In Athens
                    </li>
                </Link>
                <Link className='Link' to='/'>
                    <li>
                        The Academy
                    </li>
                </Link>
                <Link className='Link' to='/'>
                    <li>
                        Legacy
                    </li>
                </Link>
            </ul>
        </div>
     );
}
 
export default FNav;